import routerLinks from '../app/routerLinks';

const mainAppBarLinks = (t, pathname) => {
  return [
    {
      id: 1,
      name: t('main_app_bar_links.home'),
      link: 'https://fatoorah.sa/',
      section: 'hero-section'
    },
    {
      id: 2,
      name: t('main_app_bar_links.blog'),
      link: 'https://fatoorah.sa/blog/',
    },
    {
      id: 3,
      name: 'مجالات العمل',
      link: 'https://fatoorah.sa/%d9%85%d8%ac%d8%a7%d9%84%d8%a7%d8%aa-%d8%a7%d9%84%d8%b9%d9%85%d9%84/',
    },
  ];
};

export default mainAppBarLinks;
